import styled from 'styled-components';
import { SummaryTitleStyled } from '../SummaryTitleStyled';

export const SummaryTitleAP = styled(SummaryTitleStyled)``;
